export type Platform = typeof __APP__;

// @deprecated just use strings
export const Platform = {
    SBE: 'student' as const,
    PUBLIC: 'app' as const,
};
